import { render, staticRenderFns } from "./signin.vue?vue&type=template&id=c3866f88&scoped=true"
import script from "./signin.vue?vue&type=script&lang=js"
export * from "./signin.vue?vue&type=script&lang=js"
import style0 from "./signin.vue?vue&type=style&index=0&id=c3866f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3866f88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VTextField: require('/app/node_modules/vuetify/lib/components/VTextField/VTextField.js').default,VCheckbox: require('/app/node_modules/vuetify/lib/components/VCheckbox/VCheckbox.js').default,CBtn: require('/app/components/ui/button/c-btn.vue').default,VForm: require('/app/node_modules/vuetify/lib/components/VForm/VForm.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VTextField})
